/**
 * ПОЛНЫЙ ПУТЬ: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminQRCodes\AdminQRGifts.js
 * ВЕРСИЯ: 1.0.0
 * ВРЕМЯ СОЗДАНИЯ: 15.11.2025 18:05
 * 
 * ОПИСАНИЕ: Компонент управления подарочными QR кодами
 * - Список всех подарочных QR кодов
 * - Фильтрация по статусу, типу
 * - Создание новых подарков
 * - Просмотр использованных подарков
 * - Статистика распределения
 */

import React, { useState, useEffect } from 'react';
import './AdminQRGifts.css';

const AdminQRGifts = () => {
  const [gifts, setGifts] = useState([]);
  const [filteredGifts, setFilteredGifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);

  const [newGift, setNewGift] = useState({
    title: '',
    description: '',
    amount: 0,
    quantity: 1,
    template: 'standard',
    expiry_days: 7,
    is_promotional: false
  });

  useEffect(() => {
    fetchGifts();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [gifts, searchQuery, statusFilter]);

  const fetchGifts = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('authToken');
      const response = await fetch('https://qr-money.onrender.com/api/admin/qr/gifts', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const giftList = data.data || data.gifts || data || [];
      setGifts(Array.isArray(giftList) ? giftList : []);
      console.log('✅ Подарочные коды загружены:', giftList);
    } catch (err) {
      console.error('❌ Ошибка при загрузке подарочных кодов:', err);
      setError(err.message);
      setGifts(getMockGifts());
    } finally {
      setLoading(false);
    }
  };

  const getMockGifts = () => [
    {
      id: 1,
      title: 'Знакомство с платформой',
      description: '50 DAR для новых пользователей',
      amount: 50,
      quantity: 100,
      claimed: 45,
      template: 'welcome',
      status: 'active',
      is_promotional: true,
      created_at: '2025-11-01T10:00:00Z',
      expiry_days: 7
    },
    {
      id: 2,
      title: 'День рождения',
      description: '100 DAR в подарок на день рождения',
      amount: 100,
      quantity: 50,
      claimed: 12,
      template: 'birthday',
      status: 'active',
      is_promotional: false,
      created_at: '2025-11-05T10:00:00Z',
      expiry_days: 30
    },
    {
      id: 3,
      title: 'Реферальная программа',
      description: '25 DAR за каждого приглашённого друга',
      amount: 25,
      quantity: 1000,
      claimed: 234,
      template: 'referral',
      status: 'active',
      is_promotional: true,
      created_at: '2025-11-01T10:00:00Z',
      expiry_days: 365
    },
    {
      id: 4,
      title: 'Сезонная акция',
      description: '200 DAR в честь открытия новой версии',
      amount: 200,
      quantity: 30,
      claimed: 30,
      template: 'seasonal',
      status: 'completed',
      is_promotional: true,
      created_at: '2025-10-01T10:00:00Z',
      expiry_days: 14
    }
  ];

  const applyFilters = () => {
    let filtered = gifts;

    if (statusFilter !== 'all') {
      filtered = filtered.filter(g => g.status === statusFilter);
    }

    if (searchQuery.trim()) {
      filtered = filtered.filter(g =>
        g.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        g.description.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredGifts(filtered);
  };

  const handleCreateGift = async (e) => {
    e.preventDefault();

    if (!newGift.title.trim()) {
      alert('⚠️ Введите название подарка');
      return;
    }

    if (newGift.amount <= 0) {
      alert('⚠️ Сумма должна быть больше 0');
      return;
    }

    if (newGift.quantity <= 0) {
      alert('⚠️ Количество должно быть больше 0');
      return;
    }

    try {
      setCreateLoading(true);
      const token = localStorage.getItem('authToken');

      const response = await fetch('https://qr-money.onrender.com/api/admin/qr/gifts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(newGift)
      });

      if (response.ok) {
        const data = await response.json();
        setGifts([...gifts, { ...newGift, id: Date.now(), claimed: 0, status: 'active' }]);
        setNewGift({
          title: '',
          description: '',
          amount: 0,
          quantity: 1,
          template: 'standard',
          expiry_days: 7,
          is_promotional: false
        });
        setShowCreateForm(false);
        alert('✅ Подарочный код создан');
      } else {
        const errData = await response.json();
        alert(`❌ Ошибка: ${errData.message || 'при создании'}`);
      }
    } catch (err) {
      console.error('❌ Ошибка:', err);
      alert('❌ Ошибка при создании подарочного кода');
    } finally {
      setCreateLoading(false);
    }
  };

  const handleDeleteGift = async (giftId) => {
    if (!window.confirm('Вы уверены что хотите удалить этот подарочный код?')) {
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://qr-money.onrender.com/api/admin/qr/gifts/${giftId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        setGifts(gifts.filter(g => g.id !== giftId));
        alert('✅ Подарочный код удален');
      } else {
        alert('❌ Ошибка при удалении');
      }
    } catch (err) {
      console.error('❌ Ошибка:', err);
      alert('❌ Ошибка при удалении подарочного кода');
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      active: { color: 'status-active', text: '✅ Активен', icon: '🎁' },
      completed: { color: 'status-completed', text: '✔️ Закончился', icon: '📦' },
      paused: { color: 'status-paused', text: '⏸️ На паузе', icon: '⏸️' }
    };
    return badges[status] || badges.active;
  };

  const getClaimPercent = (claimed, quantity) => {
    return (claimed / quantity) * 100;
  };

  const getTemplateLabel = (template) => {
    const labels = {
      standard: '📋 Стандартный',
      welcome: '👋 Приветствие',
      birthday: '🎂 День рождения',
      referral: '👥 Реферальный',
      seasonal: '🎄 Сезонный'
    };
    return labels[template] || template;
  };

  if (loading) {
    return (
      <div className="admin-qr-gifts-page">
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <p>⏳ Загрузка подарочных кодов...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-qr-gifts-page">
      {/* ЗАГОЛОВОК */}
      <div className="gifts-header">
        <h1>🎁 Управление подарочными QR кодами</h1>
        <p>Всего подарков: {gifts.length} | Показано: {filteredGifts.length}</p>
      </div>

      {/* ОШИБКА */}
      {error && (
        <div className="error-message">
          ⚠️ {error} (используются тестовые данные)
        </div>
      )}

      {/* ФИЛЬТРЫ И КНОПКА */}
      <div className="gifts-controls">
        <div className="controls-left">
          <input
            type="text"
            className="search-input"
            placeholder="🔍 Поиск по названию или описанию..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <select
            className="filter-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">📊 Все статусы</option>
            <option value="active">✅ Активные</option>
            <option value="completed">✔️ Завершённые</option>
            <option value="paused">⏸️ На паузе</option>
          </select>
        </div>

        <button
          className="btn-create"
          onClick={() => setShowCreateForm(!showCreateForm)}
        >
          ➕ {showCreateForm ? 'Отмена' : 'Создать подарок'}
        </button>
      </div>

      {/* ФОРМА СОЗДАНИЯ */}
      {showCreateForm && (
        <div className="create-form">
          <h2>➕ Новый подарочный QR код</h2>
          
          <form onSubmit={handleCreateGift}>
            <div className="form-row">
              <div className="form-group">
                <label>Название *</label>
                <input
                  type="text"
                  value={newGift.title}
                  onChange={(e) => setNewGift({ ...newGift, title: e.target.value })}
                  className="form-input"
                  placeholder="Знакомство с платформой"
                />
              </div>

              <div className="form-group">
                <label>Сумма (DAR) *</label>
                <input
                  type="number"
                  value={newGift.amount}
                  onChange={(e) => setNewGift({ ...newGift, amount: parseFloat(e.target.value) })}
                  className="form-input"
                  min="0.1"
                  step="0.1"
                  placeholder="50"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Описание</label>
              <textarea
                value={newGift.description}
                onChange={(e) => setNewGift({ ...newGift, description: e.target.value })}
                className="form-textarea"
                placeholder="Описание подарка для пользователей"
                rows="2"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Количество *</label>
                <input
                  type="number"
                  value={newGift.quantity}
                  onChange={(e) => setNewGift({ ...newGift, quantity: parseInt(e.target.value) })}
                  className="form-input"
                  min="1"
                  placeholder="100"
                />
              </div>

              <div className="form-group">
                <label>Дней для использования</label>
                <input
                  type="number"
                  value={newGift.expiry_days}
                  onChange={(e) => setNewGift({ ...newGift, expiry_days: parseInt(e.target.value) })}
                  className="form-input"
                  min="1"
                  max="365"
                  placeholder="7"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Шаблон</label>
                <select
                  value={newGift.template}
                  onChange={(e) => setNewGift({ ...newGift, template: e.target.value })}
                  className="form-select"
                >
                  <option value="standard">📋 Стандартный</option>
                  <option value="welcome">👋 Приветствие</option>
                  <option value="birthday">🎂 День рождения</option>
                  <option value="referral">👥 Реферальный</option>
                  <option value="seasonal">🎄 Сезонный</option>
                </select>
              </div>

              <div className="form-group checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={newGift.is_promotional}
                    onChange={(e) => setNewGift({ ...newGift, is_promotional: e.target.checked })}
                  />
                  Промо подарок
                </label>
              </div>
            </div>

            <button type="submit" className="btn-submit" disabled={createLoading}>
              💾 {createLoading ? 'Создание...' : 'Создать'}
            </button>
          </form>
        </div>
      )}

      {/* СПИСОК ПОДАРКОВ */}
      <div className="gifts-grid">
        {filteredGifts.length > 0 ? (
          filteredGifts.map((gift) => {
            const claimPercent = getClaimPercent(gift.claimed, gift.quantity);
            const badge = getStatusBadge(gift.status);
            const remaining = gift.quantity - gift.claimed;

            return (
              <div key={gift.id} className="gift-card">
                <div className="gift-header">
                  <div className="gift-title-group">
                    <h3>{gift.title}</h3>
                    <span className="gift-template">
                      {getTemplateLabel(gift.template)}
                    </span>
                  </div>
                  <div className="gift-badge-group">
                    <span className={`status-badge ${badge.color}`}>
                      {badge.text}
                    </span>
                    {gift.is_promotional && (
                      <span className="promo-tag">📣 ПРОМО</span>
                    )}
                  </div>
                </div>

                {gift.description && (
                  <p className="gift-description">{gift.description}</p>
                )}

                <div className="gift-amount">
                  <span className="amount-value">{gift.amount} DAR</span>
                  <span className="amount-label">за каждый подарок</span>
                </div>

                <div className="gift-stats">
                  <div className="stat">
                    <span className="stat-label">Всего</span>
                    <span className="stat-value">{gift.quantity}</span>
                  </div>
                  <div className="stat">
                    <span className="stat-label">Получено</span>
                    <span className="stat-value claimed">{gift.claimed}</span>
                  </div>
                  <div className="stat">
                    <span className="stat-label">Осталось</span>
                    <span className="stat-value remaining">{remaining}</span>
                  </div>
                  <div className="stat">
                    <span className="stat-label">Срок (дни)</span>
                    <span className="stat-value">{gift.expiry_days}</span>
                  </div>
                </div>

                <div className="claim-progress">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${Math.min(claimPercent, 100)}%` }} />
                  </div>
                  <span className="progress-text">
                    {Math.round(claimPercent)}% получено
                  </span>
                </div>

                <div className="gift-date">
                  <span className="date-label">Создан:</span>
                  <span className="date-value">
                    {new Date(gift.created_at).toLocaleDateString('ru-RU')}
                  </span>
                </div>

                <button
                  className="btn-delete"
                  onClick={() => handleDeleteGift(gift.id)}
                  title="Удалить"
                >
                  🗑️ Удалить
                </button>
              </div>
            );
          })
        ) : (
          <div className="no-gifts">
            <p>❌ Подарочные коды не найдены</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminQRGifts;
